import Target from '../../target';
import { isAndroid, isEmbedded, isIOS } from '../useragent';

export const callNative = (...args) => {
  if (isIOS && (isEmbedded || Target.__EMBEDDED__)) {
    return require('../bridge/ios').callNative(...args);
  } else if (isAndroid && (isEmbedded || Target.__EMBEDDED__)) {
    return require('../bridge/android').callNative(...args);
  } else {
    return null;
  }
};

export const installBridge = () => {
  if (isIOS && (isEmbedded || Target.__EMBEDDED__)) {
    console.debug('Installing bridge for iOS.');
    global.callJs = require('../bridge/ios').callJs;
  } else if (isAndroid && (isEmbedded || Target.__EMBEDDED__)) {
    console.debug('Installing bridge for Android.');
    global.callJs = require('../bridge/android').callJs;
  } else {
    console.debug('No bridge to install (neither iOS nor Android).');
    global.callJs = () => {};
  }
};
